import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Stack, IconButton, InputAdornment, TextField, Container, Typography } from '@mui/material';
// components
import authService from '../services/auth.service';

import Iconify from '../components/iconify';


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const navigate = useNavigate();
  const { uid } = useParams();

  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      submit: null,
    },
    validationSchema: Yup.object(
      uid
        ? {
            password: Yup.string().max(255).required('A senha é obrigatória'),
          }
        : {
            email: Yup.string().email('Deve ser um e-mail válido').max(255).required('O e-mail é obrigatório'),
            password: Yup.string().max(255).required('A senha é obrigatória'),
          }
    ),
    onSubmit: async (values, helpers) => {
      try {
        await authService.login(values.email, values.password);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: uid ? 'Verifique sua senha' : 'Verifique seu e-mail e senha' });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Helmet>
        <title> Login | BMENU </title>
      </Helmet>

      <StyledRoot>
        {/* <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )} */}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h3" gutterBottom textAlign={'center'}>
              BMENU
            </Typography>

            <form noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={3} sx={{ my: 2 }}>
                {!uid && (
                  <TextField
                    error={!!(formik.touched.email && formik.errors.email)}
                    fullWidth
                    helperText={formik.touched.email && formik.errors.email}
                    label="EMAIL"
                    name="email"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    type="email"
                    value={formik.values.email}
                    autoComplete="off"
                  />
                )}
                <TextField
                  error={!!(formik.touched.password && formik.errors.password)}
                  fullWidth
                  helperText={formik.touched.password && formik.errors.password}
                  label="SENHA"
                  name="password"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                />
              </Stack>

              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                {/* <Checkbox name="remember" label="Remember me" />
                <Link variant="subtitle2" underline="hover">
                  Forgot password?
                </Link> */}
              </Stack>
              {formik.errors.submit && (
                <Typography color="error" sx={{ mb: 3 }} variant="body2">
                  {formik.errors.submit}
                </Typography>
              )}
              <Button fullWidth size="large" type="submit" variant="contained">
                ENTRAR
              </Button>
            </form>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
